<script lang="ts">
  import DesktopMenu from '$lib/components/common/menu/DesktopMenu.svelte'
  import { storeHeroMenu } from '$lib/js/stores';
  import { page } from '$app/stores';
	import { is_set_array } from '$lib/js/helpers';

  $: innerWidth = 0;

	let menu_levels = $page.data.menu_levels

  let firstLevel = menu_levels.firstLevel
  let secondLevel = menu_levels.secondLevel
  let thirdLevel = menu_levels.thirdLevel
</script>


<svelte:window bind:innerWidth />

{#if $storeHeroMenu && is_set_array(menu_levels.firstLevel)}
  {#if innerWidth > 1024}
    <DesktopMenu {firstLevel} {secondLevel} {thirdLevel} />
  {/if}
{/if}
